/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/**
 * Component imports.
 */
import { WebComponent } from './web.component';
import { FeedListComponent } from './feed-list/feed-list.component';
import { FeedDetailComponent } from './feed-detail/feed-detail.component';
import { MobileExploreComponent } from '../common/mobile-explore/mobile-explore.component';
import { MobileSearchComponent } from '../search/mobile-search/mobile-search.component';
import { PseRegisterComponent } from '../pse-register/pse-register.component';
import { ViewAllDocWebComponent } from './view-all-doc-web/view-all-doc-web.component';
import { RouteParamGuard } from '../auth/routeParam.guard';

const webRoutes: Routes = [
  {
    path: '', component: WebComponent,
    canActivateChild: [RouteParamGuard],
    children: [
      {
        path: 'list', component: FeedListComponent,
        data: { screen_name: 'feed list', module_name: 'Web Trends' }
      },
      {
        path: 'list/:detailId', component: FeedListComponent,
        data: { screen_name: 'feed listt', module_name: 'Web' }
      },
      {
        path: 'nejm/:id', component: FeedListComponent,
        data: { screen_name: 'feed list', module_name: 'Web Trends' }
      },
      {
        path: 'nejm/:id', component: FeedListComponent,
        data: { screen_name: 'feed list', module_name: 'Web Trends' }
      },
      {
        path: 'detail/:id', component: FeedDetailComponent,
        data: { screen_name: 'feed detail', module_name: 'Web Trends' }
      },
      { path: 'explore', component: MobileExploreComponent },
      { path: 'mobile-search', component: MobileSearchComponent },
      { path: 'registration/register/:cid', component: PseRegisterComponent },
      { path: 'registration/register', component: PseRegisterComponent },
      { path: 'viewAll', component: ViewAllDocWebComponent},

      { path: '', redirectTo: 'list', pathMatch: 'full' }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(webRoutes)
  ],
  exports: [RouterModule]
})
export class WebRoutingModule { }
